module.exports = __webpack_public_path__ + "static/ss2.eb5f9948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/cuvinte/ss2.png
// module id = 285
// module chunks = 270678402688933 277036769636407